const prepareQueryParams = (obj) => {
  let paths = []
  Object.keys(obj).forEach((key) => {
    getInnerPaths(obj[key]).map((innerPath) => {
      paths.push(`${key}${innerPath}`);
    })
  })
  return paths.join("&");
}

const getInnerPaths = (obj) => {
  if(Array.isArray(obj)) {
    return obj.reduce((paths, item) => {
      getInnerPaths(item).forEach((path) => {
        paths.push(`[]${path}`)
      })
      return paths;
    }, []);
  } else if(typeof obj === 'object' && obj !== null && obj !== undefined) {
    return Object.keys(obj).reduce((paths, key) => {
      getInnerPaths(obj[key]).forEach((path) => {
        paths.push(`[${key}]${path}`)
      })
      return paths;
    }, []);
  } else if(obj === null || obj === undefined) {
    return [`=`];
  } else {
    return [`=${obj}`];
  }
}

export default prepareQueryParams;
